export default class LocalStorageManager {
    public static save<T>(key: string, item: T) {
        localStorage.setItem(key, JSON.stringify(item))
    }

    public static load<T>(key: string, item: T) {
        const json = localStorage.getItem(key)
        if (!json || json == '') LocalStorageManager.save(key, item)
        return json ? (JSON.parse(json) as T) : item
    }
}
